interface DatePeriod {
  start: string | Date;
  end: string | Date;
}

const getLatestDates = (period: number, isos: boolean = false): string[] => {
  return [...Array(period)]
    .map((_, i) => {
      const d = new Date();
      d.setDate(d.getDate() - i - (isos ? 1 : 0));
      return isos ? d.toISOString().split('T')[0] : d.toDateString();
    })
    .reverse();
};

export const getLatestDatesArray = (period: DatePeriod): string[] => {
  const array: string[] = [];

  for (
    const dt = new Date(period.start);
    dt <= new Date(period.end);
    dt.setDate(dt.getDate() + 1)
  ) {
    array.push(new Date(dt).toISOString().split('T')[0]);
  }

  return array;
};

export default getLatestDates;
